import { ValidButton } from "../buttons/validButton";

interface ActivateOfflineModeProps {
    handleActivateOfflineMode: () => void;
    handleDesactivateOfflineMode: () => void;
    message: string;
}
const ModalHl: React.FC<ActivateOfflineModeProps> = ({
    handleActivateOfflineMode,
    handleDesactivateOfflineMode,
    message,
}) => {
    return (
        <>
            <div className="backgroundModal"></div>
            <div className="container_activeModeHl">
                <div className="modalHl">
                    <p>{message}</p>
                    <div className="buttonModalHl">
                        <ValidButton onClick={handleActivateOfflineMode} >Oui</ValidButton>
                        <ValidButton onClick={handleDesactivateOfflineMode} >Non</ValidButton>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ModalHl
